var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"sidebar-inner v-slimscroll"},[_c('div',{staticClass:"sidebar-menu"},[_c('ul',[_c('li',[_c('Skeleton',{attrs:{"count":10}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcf1616e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/agentconnect/LeftSidebar.vue
// module id = null
// module chunks = 